<template>
  <v-form v-if="tr !== null">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <h3 style="margin-bottom: 1em; font-weight: bold;">{{ isNieuw ? "Nieuwe tijdsregistratie" : "Tijdsregistratie wijzigen" }}: {{ tr.datum }}</h3>
          <p v-for="msg in algemeneFoutmeldingen" style="color: red;">{{ msg }}</p>
        </v-flex>
        <v-flex xs12 id="van_tot_container"><p style="font-size: 16px;">
          Van :
          <v-dialog ref="dialogModalStart" v-model="modal_start" :return-value.sync="tr.start" persistent lazy>
            <input type="text" slot="activator" v-model="tr.start" readonly id="txtStart" />
            <v-time-picker v-if="modal_start" v-model="tr.start" full-width format="24hr">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_start = false">Annuleren</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogModalStart.save(tr.start)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
          tot :
          <v-dialog ref="dialogModalEinde" v-model="modal_einde" :return-value.sync="tr.einde" persistent lazy>
            <input type="text" slot="activator" v-model="tr.einde" readonly />
            <v-time-picker v-if="modal_einde" v-model="tr.einde" full-width format="24hr">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_einde = false">Annuleren</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogModalEinde.save(tr.einde)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </p></v-flex>
        <v-flex xs12 id="tr_regtype">
          <v-radio-group v-model.number="tr.regtype" row>
            <v-radio :value="1" label="Werktijd"></v-radio>
            <v-radio :value="2" label="Afwezigheid"></v-radio>
          </v-radio-group>
        </v-flex>
        <template v-if="tr.regtype === 1">
          <v-flex xs12 class="wt_geg">
            <v-text-field v-model="tr.project_omschr" label="Organisatie-project" :error-messages="errors.project" readonly @click.stop="kiesProject('org')"></v-text-field>
            <v-text-field v-model="tr.eigen_project_omschr" label="Eigen project" :error-messages="errors.eigen_project" readonly @click.stop="kiesProject('eigen')"></v-text-field>
            <v-text-field v-model="tr.omschrijving" label="Omschrijving" :error-messages="errors.omschrijving"></v-text-field>
            <v-checkbox v-if="tr.hasOwnProperty('telewerk_cb')" v-model="tr.telewerk_cb" label="Telewerk" ></v-checkbox>
            <v-checkbox v-model="tr.feestdagwerk" label="Feestdagwerk" ></v-checkbox>
            <v-checkbox v-model="tr.spec_compensatie" label="Specifieke compensatieregeling" ></v-checkbox>
            <template v-if="tr.spec_compensatie">
              <v-select :items="tr.specifieke_compensatieregeling_choices" v-model="tr.specifieke_compensatieregeling" style="margin-top: 0; padding-top: 0;"></v-select>
              <v-text-field v-model="tr.reden_specifieke_compensatieregeling" label="Reden specifieke compensatieregeling" :error-messages="errors.reden_specifieke_compensatieregeling"></v-text-field>
            </template>
          </v-flex>
        </template>
        <template v-if="tr.regtype === 2">
          <v-select :items="tr.verloftype_choices" v-model="tr.verloftype" style="margin-top: 0; padding-top: 0;" label="Type afwezigheid selecteren..." solo></v-select>
          <v-text-field v-if="tr.verloftype === 'aa'" v-model="tr.reden_andere_afwezigheid" label="Reden" :error-messages="errors.reden_andere_afwezigheid"></v-text-field>
        </template>
        <template v-if="geplandOverlappend.length > 0">
          <p style="color: red;">Deze geplande tijdsregistraties overlappen met de nieuwe tijdsregistratie en zullen verwijderd worden als je op "Opslaan" klikt:</p>
          <ul>
            <li v-for="tr in geplandOverlappend" :key="tr.id">{{ tr.start | formatTijd }} - {{ tr.einde | formatTijd }}: {{ tr.omschr }}</li>
          </ul>
        </template>
      </v-layout>
    </v-container>
    <div style="text-align: center; margin: 0 0 16px 0;">
      <v-btn color="error" @click="btnVerwijderen" default v-if="verwijderen_toegelaten">{{ btnVerwijderenTekst }}</v-btn>
      <v-btn color="warning" @click="btnResetStartStop" default v-if="checkin_info">Reset start/stop</v-btn>
      <v-btn color="success" @click="trOpslaan" default>{{ btnOpslaanText }}</v-btn>
    </div>
    <v-dialog persistent scrollable v-model="projectkiezerTonen">
      <v-card>
        <v-card-title class="headline" primary-title>Project kiezen</v-card-title>
        <v-card-text style="padding-top: 0;">
          <div v-if="projdata !== undefined">
            <template v-if="projdata.favo.length > 0">
              <p class="projtitel">Favoriete projecten</p>
              <project v-for="p in projdata.favo" :key="'f' + p.id" :project="p" :depth="0" @gekozen="projectGekozen"></project>
              <p class="projtitel">Alle projecten</p>
            </template>
            <project v-for="p in projdata.alle" :key="p.id" :project="p" :depth="0" @gekozen="projectGekozen"></project>
            <p v-if="projdata.alle.length == 0" style="font-style: italic;">Geen projecten gedefiniëerd.</p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="geenProject">Geen project</v-btn>
          <v-btn flat color="primary" @click="projdata = undefined">Annuleren</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  import Project from './Project'

  function parseTijd(s) {
    const o = s.split(':')
    if (o.length !== 2) return 0
    return parseInt(o[0]) * 60 + parseInt(o[1])
  }

  export default {
    components: { Project },
    data: () => ({
      tr: null,
      errors: [],
      btnOpslaanText: "Opslaan",
      btnVerwijderenTekst: "Verwijderen",
      verwijderen_toegelaten: true,
      checkin_info: undefined,
      vandaag_gepland: [],
      modal_start: false,
      modal_einde: false,
      orgproj: undefined,
      eigenproj: undefined,
      projdata: undefined,
      project_kiezen_type: undefined
    }),
    computed: {
      ...mapState(['api']),
      apiPath: function () {
        if (this.$route.params.hasOwnProperty('datum')) {
          return 'nieuw/' + this.$route.params.datum
        } else if (this.$route.params.hasOwnProperty('id')) {
          return 'tr/' + this.$route.params.id
        } else {
          return 'checkout'
        }
      },
      isNieuw: function () {
        return (!this.$route.params.hasOwnProperty('id'))
      },
      algemeneFoutmeldingen: function() {
        if (!this.errors) return []
        return (this.errors.non_field_errors || [])
                .concat(this.errors.start || [])
                .concat(this.errors.einde || [])
      },
      geplandOverlappend: function() {
        if (!this.tr.start || !this.tr.einde) return []
        const van = parseTijd(this.tr.start)
        const tot = parseTijd(this.tr.einde)
        return this.vandaag_gepland.filter(vg => vg.einde > van && vg.start < tot)
      },
      projectkiezerTonen: function() {
        return (this.projdata !== undefined)
      }
    },
    methods: {
      ...mapMutations(['setSnackbarMsg', 'showDialog']),
      ...mapActions(['askConfirm']),
      trInladen: async function() {
        this.errors = []
        let r = await this.api.get(this.apiPath)
        if (r.data.success) {
          this.tr = r.data.trdata
          this.errors = r.data.errors
          this.btnOpslaanText = r.data.btnOpslaanText
          this.btnVerwijderenTekst = r.data.btnVerwijderenTekst
          this.checkin_info = r.data.checkin_info
          this.orgproj = r.data.orgproj
          this.eigenproj = r.data.eigenproj
          this.vandaag_gepland = r.data.vandaag_gepland || []
          this.verwijderen_toegelaten = this.$route.params.hasOwnProperty('id') && r.data.verwijderen_toegelaten
        } else {
          this.showDialog(r.data.errmsg)
          this.$router.push('/')
        }
      },
      trOpslaan: async function() {
        let r = await this.api.post(this.apiPath, this.tr)
        if (r.data.saved) {
          this.setSnackbarMsg(r.data.msg)
          this.$router.push('/')
        } else if (r.data.success) {
          this.errors = r.data.errors
        } else {
          this.showDialog(r.data.errmsg)
          this.$router.push('/')
        }
      },
      btnVerwijderen: async function() {
        if (await this.askConfirm("Weet je zeker dat je deze tijdsregistratie wil verwijderen?")) {
          let r = await this.api.post("/tr_verwijderen", {'id': this.$route.params.id})
          this.setSnackbarMsg(r.data.msg)
          if (r.data.success) this.$router.push('/')
        }
      },
      btnResetStartStop: async function() {
        if (await this.askConfirm(this.checkin_info + " Weet je zeker dat je dit tijdstip wil verwijderen?")) {
          let r = await this.api.post("/reset_checkin")
          this.setSnackbarMsg(r.data.msg)
          if (r.data.success) this.$router.push('/')
        }
      },
      kiesProject: function(t) {
        this.project_kiezen_type = t
        if (t === "org") {
          this.projdata = this.orgproj
        } else {
          this.projdata = this.eigenproj
        }
      },
      projectGekozen: function(p) {
        if (this.project_kiezen_type === "org") {
          this.tr.project = p.id
          this.tr.project_omschr = p.omschr
        } else {
          this.tr.eigen_project = p.id
          this.tr.eigen_project_omschr = p.omschr
        }
        this.projdata = undefined
      },
      geenProject: function() {
        this.projectGekozen({
          id: null,
          omschr: ""
        })
      }
    },
    watch: {
      '$route': function() {
        this.trInladen()
      }
    },
    mounted() {
      this.trInladen()
    }
  }
</script>

<style lang="stylus">

.wt_geg
  .v-input
    margin-top: 0
  .v-text-field
    padding-top: 0

#van_tot_container
  text-align: center

  input
    display: inline-block
    margin: -6px 0 -4px 8px
    padding: 6px 0 4px 0
    background-color: #ddd
    width: 64px
    text-align: center

  input#txtStart
    margin-right: 16px

#tr_regtype
  .v-input--radio-group--row
    justify-content: center
  .v-input__slot
    margin: 0
  .v-radio label
    color: black !important
  .v-radio:first-child
    margin-right: 32px

p.projtitel
  margin: 8px -8px 0 -8px
  padding: 4px 8px
  background-color: #dfdfdf
  color: black

</style>
